import { motion } from "framer-motion";
import {
    Home,
    Building2,
    Sparkles,
    Wind,
    TreePine,
    Car,
    ArrowUpRight,
} from "lucide-react";

const services = [
    {
        icon: Home,
        title: "House Washing",
        desc: "Soft wash that lifts dirt, algae and mildew from siding without damage.",
        img: "https://images.pexels.com/photos/18093637/pexels-photo-18093637.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        icon: Car,
        title: "Driveways & Concrete",
        desc: "Heavy oil stains, rust and tire marks blasted out at high PSI.",
        img: "https://images.pexels.com/photos/14965464/pexels-photo-14965464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        icon: Wind,
        title: "Window Cleaning",
        desc: "Streak-free shine — inside and out — on every pane, every time.",
        img: "https://images.pexels.com/photos/16898979/pexels-photo-16898979.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        icon: TreePine,
        title: "Deck & Patio",
        desc: "Restore the natural color of wood, pavers and stone surfaces.",
        img: "https://images.pexels.com/photos/37050707/pexels-photo-37050707.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        icon: Building2,
        title: "Commercial Cleaning",
        desc: "Storefronts, parking lots, shopping plazas — kept showroom-ready.",
        img: "https://images.pexels.com/photos/4876639/pexels-photo-4876639.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        icon: Sparkles,
        title: "Gutter & Roof",
        desc: "Clear debris, prevent overflow and extend the life of your roof.",
        img: "https://images.pexels.com/photos/9667643/pexels-photo-9667643.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
];

export default function Services() {
    return (
        <section
            id="services"
            data-testid="services-section"
            className="relative py-24 lg:py-32 bg-white"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
                    <div>
                        <div className="text-xs uppercase tracking-[0.3em] text-[#1E88E5] font-bold mb-4">
                            / What We Clean
                        </div>
                        <h2 className="font-display font-bold uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-[#0a0a0a]">
                            Six services.
                            <br />
                            <span className="text-[#1E88E5]">
                                Zero compromise.
                            </span>
                        </h2>
                    </div>
                    <p className="max-w-md text-gray-600 text-base">
                        From driveways caked in years of grime to delicate
                        window panes — we bring the right pressure, the right
                        chemistry, and the right people every time.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-black/10 border border-black/10">
                    {services.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <motion.div
                                key={s.title}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.5, delay: i * 0.05 }}
                                className="group relative bg-white hover:bg-[#fafbfc] p-8 transition-all duration-300 cursor-default overflow-hidden"
                                data-testid={`service-card-${i}`}
                            >
                                <div
                                    className="absolute inset-0 opacity-0 group-hover:opacity-10 transition-opacity duration-500 bg-cover bg-center"
                                    style={{
                                        backgroundImage: `url(${s.img})`,
                                    }}
                                />
                                <div className="relative">
                                    <div className="flex items-start justify-between mb-12">
                                        <div className="w-12 h-12 bg-[#1E88E5]/10 border border-[#1E88E5]/30 flex items-center justify-center rounded-sm group-hover:bg-[#1E88E5] transition-colors">
                                            <Icon className="w-6 h-6 text-[#1E88E5] group-hover:text-white transition-colors" />
                                        </div>
                                        <ArrowUpRight className="w-5 h-5 text-black/20 group-hover:text-[#1E88E5] group-hover:rotate-45 transition-all duration-300" />
                                    </div>

                                    <h3 className="font-display font-bold uppercase text-2xl mb-3 text-[#0a0a0a]">
                                        {s.title}
                                    </h3>
                                    <p className="text-sm text-gray-600 leading-relaxed">
                                        {s.desc}
                                    </p>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
